import { useLocation, useNavigate } from 'react-router-dom'

import { NavigationItems } from './NavigationItems'
import * as routes from '../constants/routes'
import { FeaturesName, useFeature } from '../hooks/useFeature'
import { useWorkspaceContext } from '../hooks/useWorkspace'
import { useZippieIdContext } from '../hooks/useZippieId'
import { ReactComponent as AirimpactSelectedIcon } from '../icons/AirImpact-selected.svg'
import { ReactComponent as AirimpactIcon } from '../icons/AirImpact.svg'
import { ReactComponent as IconIntegrationsSelected } from '../icons/integrations-selected.svg'
import { ReactComponent as IconIntegrations } from '../icons/integrations.svg'
import { ReactComponent as IconMonitoringDataSelected } from '../icons/monitoring-data-selected.svg'
import { ReactComponent as IconMonitoringData } from '../icons/monitoring-data.svg'
import { ReactComponent as NodeSelectedIcon } from '../icons/Nodes-selected.svg'
import { ReactComponent as NodeIcon } from '../icons/Nodes.svg'
import { ReactComponent as IconPeopleSelected } from '../icons/people-selected.svg'
import { ReactComponent as IconPeople } from '../icons/people.svg'
import { ReactComponent as IconProjectsSelected } from '../icons/projects-selected.svg'
import { ReactComponent as IconProjects } from '../icons/projects.svg'

export function MainNavigation({ isSidebarOpen }: { isSidebarOpen: boolean }) {
  const location = useLocation()
  const navigate = useNavigate()
  const { selectedNodeId } = useWorkspaceContext()
  const { isSuperAdmin } = useZippieIdContext()

  const navigationItems = {
    allProjects: {
      name: 'All projects',
      onClick: () => navigate(`/${selectedNodeId}`),
      selected: location.pathname === `/${selectedNodeId}` || location.pathname.includes('project'),
      icon: IconProjects,
      iconSelected: IconProjectsSelected,
      isFeatureEnabled: true,
    },
    people: {
      name: 'People',
      onClick: () => navigate(`/${selectedNodeId}/people`),
      selected: location.pathname.includes(routes.peopleRoute) || location.pathname.includes('person'),
      icon: IconPeople,
      iconSelected: IconPeopleSelected,
      isFeatureEnabled: useFeature(FeaturesName.workspaceEmployee),
    },
    monitoringSystem: {
      name: 'Monitoring systems',
      onClick: () => navigate(routes.monitoringSystemsRoute),
      selected: location.pathname === routes.monitoringSystemsRoute,
      icon: IconMonitoringData,
      iconSelected: IconMonitoringDataSelected,
      isHidden: true,
      isFeatureEnabled: useFeature(FeaturesName.monitoringSystem),
    },
    integrations: {
      name: 'Integrations',
      selected: false,
      icon: IconIntegrations,
      iconSelected: IconIntegrationsSelected,
      isComingSoon: true,
      isFeatureEnabled: true,
    },
    workspaces: {
      name: 'Workspaces',
      onClick: () => navigate('/admin'),
      selected: location.pathname === routes.allWorkspaces,
      icon: NodeIcon,
      IconSelected: NodeSelectedIcon,
      isHidden: !isSuperAdmin,
      isFeatureEnabled: true,
    },
    airImpact: {
      name: 'AirImpact',
      onClick: () => navigate(routes.airImpact),
      selected: location.pathname === routes.airImpact,
      icon: AirimpactIcon,
      iconSelected: AirimpactSelectedIcon,
      isHidden: true,
    },
  }
  return <NavigationItems navigationItems={navigationItems} isSidebarOpen={isSidebarOpen} />
}
